import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CartService } from '../../../../shared/services/cart.service';

@Component({
  selector: 'app-cart-button',
  standalone: false,
  templateUrl: './cart-button.component.html',
  styleUrl: './cart-button.component.scss',
})
export class CartButtonComponent {
  @Input() isOpen = false;
  @Output() toggle = new EventEmitter<void>();
  cartCount = 0;

  constructor(private cartService: CartService) {}

  ngOnInit(): void {
    this.cartService.cartCount$.subscribe((count) => {
      this.cartCount = count;
    });
  }

  onToggle(): void {
    this.toggle.emit();
  }
}
